var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pessoa && !_vm.isSocio
        ? _c(
            "el-row",
            { attrs: { span: 24 } },
            [
              _vm.isReurbInteressadoPj || _vm.isReurbPJAntigo
                ? _c(
                    "div",
                    { key: "pessoa-juridica-reurb", staticClass: "labelStyle" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararInformacoesPessoa
                              .mudouRazaoSocial
                              ? "text"
                              : "",
                            attrs: {
                              id: "RAZAO_SOCIAL_REURB_PJ",
                              label: "Razão social:",
                              content: _vm.isReurbPJAntigo
                                ? _vm.razaoSocialRequerente
                                : _vm.pessoa.pessoaJuridica.razaoSocial
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararInformacoesPessoa.mudouCNPJ
                              ? "text"
                              : "",
                            attrs: {
                              id: "CNPJ_REURB_PJ",
                              label: "CNPJ:",
                              content: _vm.isReurbPJAntigo
                                ? _vm.cnpjRequerente
                                : _vm.pessoa.pessoaJuridica.cnpj
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoa.pessoaJuridica
                            ? _c("app-display", {
                                attrs: {
                                  id: "CLASSIFICACAO_REURB_PJ",
                                  label: "Classificação:",
                                  content:
                                    _vm.pessoa.pessoaJuridica &&
                                    _vm.pessoa.pessoaJuridica.classificacao
                                      ? _vm.formatarTexto(
                                          _vm.pessoa.pessoaJuridica
                                            .classificacao
                                        )
                                      : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isReurbInteressadoPj || _vm.isReurbPJAntigo
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-divider", {
                        attrs: { label: "Representante legal" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPf || _vm.isReurbInteressadoPj || _vm.isReurbPJAntigo
                ? _c(
                    "div",
                    { key: "pessoa-fisica", staticClass: "labelStyle" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.temCertidaoCasamento
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNumeroCertidaoCasamento
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NUMERO_CERTIDAO_CASAMENTO",
                                  label: "Número da certidão de casamento:",
                                  content: _vm.pessoaExibicao.certidaoCasamento
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.temCertidaoCasamento
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouDataCasamento
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "DATA_CASAMENTO",
                                  label: "Data de casamento:",
                                  content: _vm.formatDate(
                                    _vm.pessoaExibicao.dataCasamento
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.cpf
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouNome
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NOME_INTERESSADO_CONJUGE",
                                  label: _vm.temCertidaoCasamento
                                    ? "Cônjuge/Companheiro(a):"
                                    : "Nome:",
                                  content: _vm.pessoaExibicao.nome
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      !_vm.isProcessoFisico && !_vm.isBancoDados
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouApelido
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "APELIDO",
                                  label: "Apelido:",
                                  content: _vm.pessoaExibicao.apelido
                                    ? _vm.pessoaExibicao.apelido
                                    : "-"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.cpf
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouCPF
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "CPF",
                                  label: "CPF:",
                                  content: _vm.pessoaExibicao.cpf
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isReurb && _vm.data
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouDataNascimento
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "DATA_NASCIMENTO",
                                  label: "Data de nascimento:",
                                  content: _vm.data
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouDataNascimento
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "DATA_NASCIMENTO_REURB",
                                  label: "Data de nascimento:",
                                  content: _vm.formatDate(
                                    _vm.pessoaExibicao.dataNascimento
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.sexo && !_vm.isReurb
                            ? _c("app-display", {
                                attrs: {
                                  id: "SEXO",
                                  label: "Sexo:",
                                  content: _vm.formatarTexto(
                                    _vm.pessoaExibicao.sexo
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                attrs: {
                                  id: "SEXO_REURB",
                                  label: "Sexo:",
                                  content: _vm.formatarTexto(
                                    _vm.pessoaExibicao.sexo
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.tempoMoradia
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouTempoMoradia
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "TEMPO_MORADIA",
                                  label: "Tempo moradia:",
                                  content:
                                    _vm.pessoaExibicao.tempoMoradia + " anos"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.nacionalidade
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNacionalidade
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NACIONALIDADE",
                                  label: "Nacionalidade:",
                                  content: _vm.getGentilico(
                                    _vm.pessoaExibicao.nacionalidade
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      !_vm.isBancoDados
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.pessoaExibicao.municipio ||
                              (_vm.pessoaExibicao.naturalidade && !_vm.isReurb)
                                ? _c("app-display", {
                                    class: _vm.compararInformacoesPessoa
                                      .mudouNaturalidade
                                      ? "text"
                                      : "",
                                    attrs: {
                                      id: "NATURALIDADE",
                                      label: "Naturalidade:",
                                      content: _vm.getNaturalidade(
                                        _vm.pessoaExibicao
                                      )
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNaturalidade
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NATURALIDADE_REURB",
                                  label: "Naturalidade:",
                                  content: _vm.getNaturalidadeReurb(
                                    _vm.pessoaExibicao
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.rg && !_vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouRG
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "RG",
                                  label: "RG:",
                                  content: _vm.pessoaExibicao.rg
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouRG
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "RG_REURB",
                                  label: "RG:",
                                  content: _vm.pessoaExibicao.rg
                                    ? _vm.pessoaExibicao.rg
                                    : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.orgaoExpedidor && !_vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouOrgaoExpedidor
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "ORGAO_EXPEDIDOR",
                                  label: "Órgão expedidor:",
                                  content: _vm.getOrgaoExpedidor(
                                    _vm.pessoaExibicao.orgaoExpedidor
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouOrgaoExpedidor
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "ORGAO_EXPEDIDOR_REURB",
                                  label: "Órgão expedidor:",
                                  content:
                                    _vm.pessoa &&
                                    _vm.pessoaExibicao &&
                                    _vm.pessoaExibicao.orgaoExpedidor
                                      ? _vm.getOrgaoExpedidor(
                                          _vm.pessoaExibicao.orgaoExpedidor
                                        )
                                      : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb &&
                          _vm.pessoaExibicao.descricaoOrgaoExpedidor
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouOrgaoExpedidor
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "ORGAO_EXPEDIDOR_DESCRICAO_REURB",
                                  label: "Descrição órgão expedidor:",
                                  content:
                                    _vm.pessoa &&
                                    _vm.pessoaExibicao &&
                                    _vm.pessoaExibicao.descricaoOrgaoExpedidor
                                      ? _vm.getDescricaoOrgaoExpedidor(
                                          _vm.pessoaExibicao
                                            .descricaoOrgaoExpedidor,
                                          _vm.pessoaExibicao.orgaoExpedidor
                                        )
                                      : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isBancoDados && _vm.pessoaExibicao.estadoCivil
                            ? _c("app-display", {
                                attrs: {
                                  id: "ESTADO_CIVIL_BANCO_DADOS",
                                  label: "Estado civil:",
                                  content: _vm.getEstadoCivil(
                                    _vm.pessoaExibicao.estadoCivil
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isConjuge
                            ? _c("app-display-multiple", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouTelefones
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "TELEFONES",
                                  label: "Telefone(s):",
                                  content: _vm.formatTelefone(
                                    _vm.pessoa.telefones
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isConjuge &&
                          !_vm.isProcessoFisico &&
                          !_vm.isBancoDados
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouEmail
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "EMAIL_INTERESSADO",
                                  label: "E-mail:",
                                  content: _vm.getEmail(_vm.pessoa.email)
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isReurb && _vm.pessoaExibicao.profissao
                            ? _c("app-display", {
                                attrs: {
                                  id: "PROFISSAO",
                                  label: "Profissão:",
                                  content: _vm.pessoaExibicao.profissao
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb && _vm.pessoaExibicao.profissao
                            ? _c("app-display", {
                                attrs: {
                                  id: "PROFISSAO_REURB",
                                  label: "Profissão:",
                                  content: _vm.pessoaExibicao.profissao
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.nomeDaMae && !_vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNomeDaMae
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NOME_MAE",
                                  label: "Nome da mãe:",
                                  content: _vm.pessoaExibicao.nomeDaMae
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb && !_vm.isConjuge
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNomeDaMae
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NOME_MAE_REURB",
                                  label: "Nome da mãe:",
                                  content: _vm.pessoaExibicao.nomeDaMae
                                    ? _vm.pessoaExibicao.nomeDaMae
                                    : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.nomeDoPai && !_vm.isReurb
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNomeDoPai
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NOME_PAI",
                                  label: "Nome do pai:",
                                  content: _vm.pessoaExibicao.nomeDoPai
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb &&
                          !_vm.isConjuge &&
                          !_vm.pessoaExibicao.paiNaoRegistrado
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouNomeDoPai
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "NOME_PAI_REURB",
                                  label: "Nome do pai:",
                                  content: _vm.pessoaExibicao.nomeDoPai
                                    ? _vm.pessoaExibicao.nomeDoPai
                                    : "Sem registro"
                                }
                              })
                            : _vm._e(),
                          _vm.pessoaExibicao.paiNaoRegistrado
                            ? _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .paiNaoRegistrado
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "PAI_NAO_REGISTRADO_REURB",
                                  label: "Nome do pai:",
                                  content: "Não registrado"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb &&
                          _vm.membroFamilia &&
                          _vm.membroFamilia.rendaMembro
                            ? _c("app-display", {
                                class: _vm.compararRendaFamiliar ? "text" : "",
                                attrs: {
                                  id: "RENDA",
                                  label: "Renda:",
                                  content: _vm.formatRenda(
                                    _vm.membroFamilia.rendaMembro
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                attrs: {
                                  id: "PROGRAMA_SOCIAL",
                                  label: "Programa social:",
                                  content:
                                    _vm.membroFamilia &&
                                    _vm.membroFamilia.programaSocial
                                      ? _vm.membroFamilia.programaSocial
                                      : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb
                            ? _c("app-display", {
                                attrs: {
                                  id: "OBSERVACOES_RENDA",
                                  label: "Observações referentes à renda:",
                                  content:
                                    _vm.membroFamilia &&
                                    _vm.membroFamilia.observacoesRenda
                                      ? _vm.membroFamilia.observacoesRenda
                                      : "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb && _vm.estadoCivilExibicao
                            ? _c("app-display", {
                                attrs: {
                                  id: "ESTADO_CIVIL",
                                  label: "Estado civil:",
                                  content: _vm.getEstadoCivil(
                                    _vm.estadoCivilExibicao
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.isReurb &&
                          _vm.pessoaExibicao.separacaoFato != null
                            ? _c("app-display", {
                                attrs: {
                                  id: "SEPARACAO_FATO",
                                  label: "Separação de fato:",
                                  content: _vm.pessoaExibicao.separacaoFato
                                    ? "Sim"
                                    : "Não"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.isProcessoFisico
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                attrs: {
                                  id: "TIPO_DOCUMENTO",
                                  label: "Tipo de documento:",
                                  content:
                                    _vm.pessoaExibicao.tipoDocumento || "-"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isProcessoFisico
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.pessoaExibicao.tipoDocumento == "OUTROS"
                                ? _c("app-display", {
                                    attrs: {
                                      id: "OUTROS",
                                      label: "Outros:",
                                      content:
                                        _vm.pessoaExibicao.outrosTipoDocumento
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.pessoaExibicao.filhoMenorDe16 === true ||
                          _vm.pessoaExibicao.filhoMenorDe16 === false
                            ? _c("app-display", {
                                attrs: {
                                  id: "POSSUI_FILHO_MENOR",
                                  label: "Possui filho menor de 16 anos:",
                                  content: _vm.pessoaExibicao.filhoMenorDe16
                                    ? "Sim"
                                    : "Não"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.rendaFamiliar
                            ? _c("app-display", {
                                class: _vm.compararRendaFamiliar ? "text" : "",
                                attrs: {
                                  id: "RENDA_FAMILIAR",
                                  label: "Renda familiar:",
                                  content: _vm.rendaFamiliar.includes("R$")
                                    ? _vm.rendaFamiliar
                                    : "R$ " + _vm.rendaFamiliar
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isPf && !_vm.isReurb
                ? _c(
                    "div",
                    { key: "pessoa-juridica" },
                    [
                      _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararInformacoesPessoa.mudouCNPJ
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "CNPJ_PJ",
                                  label: "CNPJ:",
                                  content: _vm.pessoa.pessoaJuridica.cnpj
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararInformacoesPessoa
                                  .mudouRazaoSocial
                                  ? "text"
                                  : "",
                                attrs: {
                                  id: "RAZAO_SOCIAL_PJ",
                                  label: _vm.razaoSocialName,
                                  content: _vm.pessoa.pessoaJuridica.razaoSocial
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display-multiple", {
                                    class: _vm.compararInformacoesPessoa
                                      .mudouTelefones
                                      ? "text"
                                      : "",
                                    attrs: {
                                      id: "TELEFONES_PJ",
                                      label: "Telefone(s):",
                                      content: _vm.pessoa.telefones
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        class: _vm.compararInformacoesPessoa
                                          .mudouEmail
                                          ? "text"
                                          : "",
                                        attrs: {
                                          id: "EMAIL_PJ",
                                          label: "E-mail:",
                                          content: _vm.pessoa.email
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "NOME_PRESIDENTE_PJ",
                                          label:
                                            "Nome do presidente da associação/empresa:",
                                          content:
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao.nome
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "CPF_PRESIDENTE_PJ",
                                          label:
                                            "CPF do presidente da associação/empresa:",
                                          content:
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao.cpf
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "RG_PRESIDENTE_PJ",
                                          label:
                                            "RG do presidente da associação/empresa:",
                                          content:
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao.rg || "-"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "TIPO_DOCUMENTO_PJ",
                                          label: "Tipo de documento:",
                                          content:
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao
                                              .tipoDocumento || "-"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge &&
                                  _vm.pessoa.pessoaJuridica.presidenteAssociacao
                                    .tipoDocumento == "OUTROS"
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "OUTROS_PJ",
                                          label: "Outros:",
                                          content:
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao
                                              .outrosTipoDocumento || "-"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isProcessoFisico
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  !_vm.isConjuge
                                    ? _c("app-display", {
                                        attrs: {
                                          id: "ORGAO_EXPEDIDOR_PJ",
                                          label: "Órgão expedidor:",
                                          content: _vm.getOrgaoExpedidor(
                                            _vm.pessoa.pessoaJuridica
                                              .presidenteAssociacao
                                              .orgaoExpedidor
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.pessoa && _vm.isSocio
        ? _c("el-row", { attrs: { span: 24 } }, [
            _vm.pessoa.pessoa.isPessoaFisica
              ? _c(
                  "div",
                  { key: "pessoa-fisica" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouNome
                            ? "text"
                            : "",
                          attrs: {
                            id: "NOME_SOCIO",
                            label: "Nome:",
                            content: _vm.pessoa.pessoa.pessoaFisica.nome
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouCPF
                            ? "text"
                            : "",
                          attrs: {
                            id: "CPF_SOCIO",
                            label: "CPF:",
                            content: _vm.pessoa.pessoa.pessoaFisica.cpf
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.rg
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouRG
                                ? "text"
                                : "",
                              attrs: {
                                id: "RG_SOCIO",
                                label: "RG:",
                                content: _vm.pessoa.pessoa.pessoaFisica.rg
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.funcao
                          ? _c("app-display", {
                              attrs: {
                                id: "FUNCAO_SOCIO",
                                label: "Função:",
                                content: _vm.getFuncao(_vm.pessoa.funcao)
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.nacionalidade
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNacionalidade
                                ? "text"
                                : "",
                              attrs: {
                                id: "NACIONALIDADE_SOCIO",
                                label: "Nacionalidade:",
                                content: _vm.getGentilico(
                                  _vm.pessoa.pessoa.pessoaFisica.nacionalidade
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.email
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouEmail
                                ? "text"
                                : "",
                              attrs: {
                                id: "EMAIL_SOCIO",
                                label: "E-mail:",
                                content: _vm.pessoa.pessoa.email
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouEstadoCivil
                            ? "text"
                            : "",
                          attrs: {
                            id: "ESTADO_CIVIL_SOCIO",
                            label: "Estado civil:",
                            content: _vm.getEstadoCivil(
                              _vm.pessoa.pessoa.pessoaFisica.estadoCivil
                            )
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.data
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouDataNascimento
                                ? "text"
                                : "",
                              attrs: {
                                id: "DATA_NASCIMENTO_SOCIO",
                                label: "Data de nascimento:",
                                content: _vm.data
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.orgaoExpedidor
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouOrgaoExpedidor
                                ? "text"
                                : "",
                              attrs: {
                                id: "ORGAO_EXPEDIDOR_SOCIO",
                                label: "Órgão expedidor:",
                                content: _vm.getOrgaoExpedidor(
                                  _vm.pessoa.pessoa.pessoaFisica.orgaoExpedidor
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.municipio
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNaturalidade
                                ? "text"
                                : "",
                              attrs: {
                                id: "NATURALIDADE_SOCIO",
                                label: "Naturalidade:",
                                content: _vm.getNaturalidade(
                                  _vm.pessoa.pessoa.pessoaFisica
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.isSocioRepresentanteLegal !== null &&
                        _vm.pessoa.isSocioRepresentanteLegal !== ""
                          ? _c("app-display", {
                              class: _vm.compararIsSocioRepresentanteLegal
                                ? "text"
                                : "",
                              attrs: {
                                id: "REPRESENTANTE_LEGAL_SOCIO",
                                label: "O sócio é representante legal?",
                                content: _vm.pessoa.isSocioRepresentanteLegal
                                  ? "Sim"
                                  : "Não"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.nomeDaMae
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNomeDaMae
                                ? "text"
                                : "",
                              attrs: {
                                id: "NOME_MAE_SOCIO",
                                label: "Nome da mãe:",
                                content:
                                  _vm.pessoa.pessoa.pessoaFisica.nomeDaMae
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display-multiple", {
                          class: _vm.compararInformacoesPessoa.mudouTelefones
                            ? "text"
                            : "",
                          attrs: {
                            label: ":",
                            content: _vm.pessoa.pessoa.telefones
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.pessoa.pessoa.isPessoaFisica && !_vm.isReurb
              ? _c(
                  "div",
                  { key: "pessoa-juridica" },
                  [
                    _c(
                      "el-row",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouCNPJ
                                ? "text"
                                : "",
                              attrs: {
                                id: "CNPJ",
                                label: "CNPJ:",
                                content: _vm.pessoa.pessoa.pessoaJuridica.cnpj
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouRazaoSocial
                                ? "text"
                                : "",
                              attrs: {
                                id: "RAZAO_SOCIAL",
                                label: _vm.razaoSocialName,
                                content:
                                  _vm.pessoa.pessoa.pessoaJuridica.razaoSocial
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display-multiple", {
                              class: _vm.compararInformacoesPessoa
                                .mudouTelefones
                                ? "text"
                                : "",
                              attrs: {
                                id: "TELEFONES",
                                label: "Telefone(s):",
                                content: _vm.pessoa.pessoa.telefones
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            !_vm.isConjuge
                              ? _c("app-display", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouEmail
                                    ? "text"
                                    : "",
                                  attrs: {
                                    id: "EMAIL",
                                    label: "E-mail:",
                                    content: _vm.pessoa.email
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d70a6b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d70a6b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ma/InformacoesPessoa.vue
// module id = null
// module chunks = 